export default "__VITE_ASSET__3EZk5qCY__"